module.exports = __webpack_public_path__ + "static/media/5-697c.5485c7bf.png";